module.exports = __webpack_public_path__ + "static/lucaswork4-fa09fdb50e7530c80f8a8ebab11f85b1.jpg";